import { project } from '@/lib/project';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';
import { BreadcrumbJsonLd } from 'next-seo';
import Link from 'next/link';

export function BreadcrumbHome({ page }) {
	return (
		<div>
			<Link
				title={page.name}
				href={page.href}
				locale={page.locale}
				className="text-gray-700"
				prefetch={false}
			>
				<HomeIcon
					className="h-5 w-5 shrink-0 text-gray-700"
					aria-hidden="true"
				/>
				<span className="sr-only">Home</span>
			</Link>
		</div>
	);
}

export function BreadcrumbItem({ page }) {
	return (
		<div className="flex items-center capitalize">
			<ChevronRightIcon
				className="h-5 w-5 shrink-0 text-gray-700"
				aria-hidden="true"
			/>
			{page.current ? (
				<span
					className="ml-4 text-sm text-gray-700"
					dangerouslySetInnerHTML={{ __html: page.name }}
				/>
			) : (
				<Link
					prefetch={false}
					title={page.name}
					href={page.href}
					locale={page.locale}
					className="ml-4 text-sm font-semibold text-gray-700 hover:text-gray-900"
					aria-current={page.current ? 'page' : undefined}
					dangerouslySetInnerHTML={{ __html: page.name }}
				/>
			)}
		</div>
	);
}
export default function Breadcrumbs({ pages, fullWidth, className }) {
	if (!pages) return null;
	pages.forEach((page) => {
		page.url = `https://${project.domain}${page.href}`;
	});

	return (
		<>
			<BreadcrumbJsonLd
				itemListElements={pages.map((page, idx) => ({
					position: ++idx,
					name: page.name,
					item: page.url,
				}))}
			/>

			<div className={clsx('bg-slate-100')}>
				<div
					className={clsx(
						'container mx-auto px-4 py-2 lg:px-8',
						fullWidth && 'max-w-full',
						className
					)}
				>
					<nav className="flex overflow-auto" aria-label="Breadcrumb">
						<ol
							role="list"
							className="scrollbar-hide flex items-center space-x-4 overflow-x-scroll"
						>
							{pages.map((page, idx) => (
								<li key={page.name} className="shrink-0">
									{idx == 0 ? (
										<BreadcrumbHome page={page} />
									) : (
										<BreadcrumbItem page={page} />
									)}
								</li>
							))}
						</ol>
					</nav>
				</div>
			</div>
		</>
	);
}
